class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    this.featured = this.querySelector('[data-featured-media]');
    this.querySelectorAll('[data-media-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const src = button.getAttribute('data-src');
        const alt = button.getAttribute('data-alt') || '';
        if (this.featured && src) {
          this.featured.src = src;
          this.featured.alt = alt;
        }
      });
    });
  }
}
customElements.define('product-media-gallery', ProductMediaGallery);

class VariantSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select[name="id"]');
    this.priceTarget = document.querySelector('[data-product-price]');
    this.submit = document.querySelector('[data-product-submit]');
    if (!this.select) return;
    this.select.addEventListener('change', () => this.update());
  }
  update() {
    const option = this.select.options[this.select.selectedIndex];
    if (!option) return;
    const available = option.getAttribute('data-available') === 'true';
    const price = option.getAttribute('data-price');
    const addLabel = this.submit?.getAttribute('data-add-label') || 'Add to cart';
    if (this.priceTarget && price) this.priceTarget.textContent = price;
    if (this.submit) {
      this.submit.disabled = !available;
      this.submit.textContent = available ? addLabel : 'Sold out';
    }
  }
}
customElements.define('variant-select', VariantSelect);
